import * as React from "react";

import { getNodeText } from "@/lib/react-helpers";
import { cn } from "@/lib/utils";

import type { ButtonProps } from "./button";
import { buttonVariants } from "./button-variants";
import type { LinkProps } from "./link";
import { Link } from "./link";

export interface CtaLinkProps
  extends LinkProps, Pick<ButtonProps, "size" | "variant"> {}

const CtaLink = React.forwardRef<HTMLAnchorElement, CtaLinkProps>(
  ({ className, variant, external, size, href, ...props }, ref) => (
    <Link
      ref={ref}
      external={external}
      href={href}
      data-ph-capture-attribute-cta_label={
        (getNodeText(props.children) ?? props.id) || undefined
      }
      data-ph-capture-attribute-cta_url={href}
      className={cn(buttonVariants({ variant, size }), className)}
      {...props}
    />
  )
);
CtaLink.displayName = "CtaLink";

export { CtaLink };
